import { ChakraProvider } from "@chakra-ui/react"
import { QueryClient, QueryClientProvider } from "react-query"
import { extendedTheme } from "styles"
import { ToastContainer } from "react-toastify"

import RoutesLayout from "components/templates/RoutesLayouts"
import Fonts from "styles/components/Fonts"

import UIProvider from "providers/UIProvider"
import AppProvider from "providers/AppProvider"
import ConfirmationModal from "components/shared/modals/ConfirmationModal"
import ResponseModal from "components/shared/modals/ResponseModal"
import CarOnPlaceModal from "components/shared/modals/CarOnPlaceModal"

import "./styles/index.scss"
import "utils/momentUtils"
import "react-toastify/dist/ReactToastify.min.css";

const queryClient = new QueryClient()

const App = () => {
  return (
    <ChakraProvider theme={extendedTheme}>
      <Fonts />
      <QueryClientProvider client={queryClient}>
        <UIProvider>
      <AppProvider>
          
            <>
              <ToastContainer 
                toastStyle={{ borderColor: "red" }}
              />
              <RoutesLayout />
              <ConfirmationModal />
              <ResponseModal />
              <CarOnPlaceModal />
            </>
          </AppProvider>
            </UIProvider>
        
      </QueryClientProvider>
    </ChakraProvider>
  )
}
export default App
